<template>
    <div>
        <!-- Modal Backdrop -->
        <div
                v-if="isdisplay"
                class="fixed inset-0 z-50 bg-gray-900 bg-opacity-50 transition-opacity duration-300"
                @click="close"
        ></div>

        <!-- Modal -->
        <div
                v-if="isdisplay"
                class="fixed inset-0 z-50 overflow-y-auto"
                tabindex="-1"
        >
            <div class="flex items-center justify-center min-h-screen p-4">
                <div class="relative bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-hidden">
                    <!-- Modal Header -->
                    <div class="flex items-center justify-between px-6 py-4 border-b bg-gray-50">
                        <div class="flex items-center space-x-3">
                            <div class="p-2 rounded-lg" :class="getHeaderIconColor()">
                                <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path
                                            v-if="typeaction === 'add'"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                    />
                                    <path
                                            v-else
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                    />
                                </svg>
                            </div>
                            <div>
                                <h3 class="text-lg font-semibold text-gray-900">
                                    {{ titlemodal }}
                                </h3>
                                <p class="text-sm text-gray-500">
                                    {{ typeaction === 'add' ? 'Ajouter un nouvel utilisateur' : 'Modifier les informations utilisateur' }}
                                </p>
                            </div>
                        </div>
                        <button
                                @click="close"
                                class="text-gray-400 hover:text-gray-500 focus:outline-none transition-colors"
                                type="button"
                        >
                            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
                            </svg>
                        </button>
                    </div>

                    <!-- Scrollable Content -->
                    <div class="overflow-auto max-h-[calc(90vh-140px)]">
                        <div class="p-6">
                            <!-- Success Message -->
                            <div
                                    v-if="messagesucces"
                                    class="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg flex items-center"
                            >
                                <div class="flex-shrink-0">
                                    <svg class="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                                    </svg>
                                </div>
                                <div class="ml-3">
                                    <p class="text-sm text-green-700" v-html="messagesucces"></p>
                                </div>
                            </div>

                            <!-- Error Message -->
                            <div
                                    v-if="messageerror"
                                    class="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg flex items-center"
                            >
                                <div class="flex-shrink-0">
                                    <svg class="w-5 h-5 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
                                    </svg>
                                </div>
                                <div class="ml-3">
                                    <p class="text-sm text-red-700" v-html="messageerror"></p>
                                </div>
                            </div>

                            <!-- Tabs -->
                            <div class="border-b border-gray-200 mb-6">
                                <nav class="flex -mb-px space-x-8">
                                    <button
                                            type="button"
                                            class="py-2 px-1 border-b-2 font-medium text-sm transition-colors duration-200"
                                            :class="activeTab === 'basic'
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
                                            @click="activeTab = 'basic'"
                                    >
                                        <div class="flex items-center space-x-2">
                                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                                            </svg>
                                            <span>Informations de base</span>
                                        </div>
                                    </button>

                                    <!-- Additional tabs can be added here -->
                                    <button
                                            v-if="typeaction === 'update'"
                                            type="button"
                                            class="py-2 px-1 border-b-2 font-medium text-sm transition-colors duration-200 hidden"
                                            :class="activeTab === 'advanced'
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
                                            @click="activeTab = 'advanced'"
                                    >
                                        <div class="flex items-center space-x-2">
                                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                                            </svg>
                                            <span>Paramètres avancés</span>
                                        </div>
                                    </button>
                                </nav>
                            </div>

                            <!-- Tab Content -->
                            <div v-if="activeTab === 'basic'" class="space-y-6">
                                <!-- Admin User View (Read-only) -->
                                <div v-if="parseFloat(Items.useline) === 2" class="space-y-4">
                                    <div class="p-4 bg-blue-50 border border-blue-200 rounded-lg">
                                        <div class="flex items-start">
                                            <svg class="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
                                            </svg>
                                            <div class="ml-3">
                                                <h4 class="text-sm font-medium text-blue-800">Utilisateur Administrateur</h4>
                                                <p class="text-sm text-blue-600 mt-1">
                                                    Cet utilisateur est un administrateur système. Certains champs sont en lecture seule.
                                                </p>
                                            </div>
                                        </div>
                                    </div>


 


                                    <div class="grid grid-cols-1 gap-4">
                                        <div>
                                            <label class="block text-sm font-medium text-gray-700 mb-2">
                                                Nom et prénom(s) <span class="text-red-500">*</span>
                                            </label>
                                            <div class="relative">
                                                <input
                                                        v-model="Items.name"
                                                        type="text"
                                                        class="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-700"
                                                        placeholder="Nom et prénom(s)"
                                                        readonly
                                                />
                                                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                                    <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fill-rule="evenodd" d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z" clip-rule="evenodd"/>
                                                    </svg>
                                                </div>
                                            </div>
                                            <p class="mt-1 text-xs text-gray-500">Lecture seule - utilisateur système</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- Regular User View (Editable) -->
                                <div v-else class="space-y-6">
                                    <!-- User Information -->
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <!-- Name -->
                                        <div>
                                            <label class="block text-sm font-medium text-gray-700 mb-2">
                                                Nom et prénom(s) <span class="text-red-500">*</span>
                                            </label>
                                            <div class="relative">
                                                <input
                                                        v-model="Items.name"
                                                        type="text"
                                                        :class="[
                            'w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500',
                            validationErrors.name ? 'border-red-300' : 'border-gray-300'
                          ]"
                                                        @blur="validateField('name')"
                                                />
                                                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                                    <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd"/>
                                                    </svg>
                                                </div>
                                            </div>
                                            <div v-if="validationErrors.name" class="mt-1 flex items-center text-red-600 text-xs">
                                                <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                                                </svg>
                                                {{ validationErrors.name }}
                                            </div>
                                        </div>

                                        <!-- Login -->
                                        <div>
                                            <label class="block text-sm font-medium text-gray-700 mb-2">
                                                Login <span class="text-red-500">*</span>
                                            </label>
                                            <div class="relative">
                                                <input v-if="!logindisabled"
                                                        v-model="Items.login"
                                                        type="text"
                                                        :class="[
                            'w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500',
                            validationErrors.login ? 'border-red-300' : 'border-gray-300'
                          ]"
                                                        @blur="validateField('login')"
                                                />
                                                <input v-else
                                                       disabled
                                                       :value="Items.login"
                                                       type="text"
                                                       class="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 border-gray-300"

                                                />
                                                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                                    <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd"/>
                                                    </svg>
                                                </div>
                                            </div>




                                            <div v-if="validationErrors.login" class="mt-1 flex items-center text-red-600 text-xs">
                                                <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                                                </svg>
                                                {{ validationErrors.login }}
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Group and Profile -->
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <!-- Group -->
                                        <div>
                                            <label class="block text-sm font-medium text-gray-700 mb-2">
                                                Groupe <span class="text-red-500">*</span>
                                            </label>
                                            <div class="relative">
                                                <select
                                                        v-model="Items.groupeusers"
                                                        :class="[
                            'w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none bg-white',
                            validationErrors.groupeusers ? 'border-red-300' : 'border-gray-300'
                          ]"
                                                        @change="validateField('groupeusers')"
                                                >
                                                    <option value="">Sélectionner un groupe</option>
                                                    <option value="NONE">NONE</option>
                                                </select>
                                                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                                    <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
                                                    </svg>
                                                </div>
                                            </div>
                                            <div v-if="validationErrors.groupeusers" class="mt-1 flex items-center text-red-600 text-xs">
                                                <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                                                </svg>
                                                {{ validationErrors.groupeusers }}
                                            </div>
                                        </div>

                                        <!-- Profile -->
                                        <div>
                                            <label class="block text-sm font-medium text-gray-700 mb-2">
                                                Profil <span class="text-red-500">*</span>
                                            </label>
                                            <div class="relative">
                                                <select
                                                        v-model="Items.sysrole"
                                                        :class="[
                            'w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none bg-white',
                            validationErrors.sysrole ? 'border-red-300' : 'border-gray-300'
                          ]"
                                                        @change="validateField('sysrole')"
                                                >
                                                    <option :value="null">Sélectionner un profil</option>
                                                    <option
                                                            v-for="(profile, index) in alldata"
                                                            :key="index"
                                                            :value="profile"
                                                    >
                                                        {{ profile.role }}
                                                    </option>
                                                </select>
                                                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                                    <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
                                                    </svg>
                                                </div>
                                            </div>
                                            <div v-if="validationErrors.sysrole" class="mt-1 flex items-center text-red-600 text-xs">
                                                <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                                                </svg>
                                                {{ validationErrors.sysrole }}
                                            </div>

                                            <!-- Profile Description -->
                                            <div v-if="Items.sysrole" class="mt-3 p-3 bg-gray-50 rounded-lg border border-gray-200">
                                                <div class="flex items-start">
                                                    <svg class="w-4 h-4 text-gray-400 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
                                                    </svg>
                                                    <div class="ml-2">
                                                        <p class="text-xs text-gray-600">
                                                            <span class="font-medium">Description:</span>
                                                            {{ Items.sysrole.description || 'Aucune description disponible' }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Agences Multi-Select -->
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-2">
                                            Annexe(s)
                                        </label>

                                        <!-- Selected Tags -->
                                        <div class="flex flex-wrap gap-1 mb-2">
                                            <span v-for="(ag, i) in Items.agence" :key="i"
                                                  class="inline-flex items-center px-2 py-1 text-xs bg-indigo-100 text-indigo-800 rounded-full">
                                                {{ ag.name }}
                                                <button @click="removeAgence(i)" type="button" class="ml-1 text-indigo-600 hover:text-indigo-900">
                                                    <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
                                                    </svg>
                                                </button>
                                            </span>
                                            <span v-if="!Items.agence || Items.agence.length === 0" class="text-sm text-gray-400">Aucune annexe sélectionnée</span>
                                        </div>

                                        <!-- Dropdown -->
                                        <div class="relative">
                                            <button @click="toggleAgenceDropdown" type="button"
                                                    class="w-full px-3 py-2 border border-gray-300 rounded-lg text-left text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 flex justify-between items-center">
                                                <span :class="{ 'text-gray-400': !Items.agence || Items.agence.length === 0 }">
                                                    {{ (!Items.agence || Items.agence.length === 0) ? 'Sélectionner les annexes...' : Items.agence.length + ' annexe(s) sélectionnée(s)' }}
                                                </span>
                                                <svg class="w-4 h-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
                                                </svg>
                                            </button>

                                            <div v-if="agenceDropdownOpen"
                                                 class="absolute z-50 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-56 overflow-auto">
                                                <div class="p-2 sticky top-0 bg-white border-b">
                                                    <input v-model="agenceSearch" type="text" ref="agenceSearchInput"
                                                           class="w-full px-2 py-1.5 text-sm border border-gray-200 rounded focus:outline-none focus:border-blue-500"
                                                           placeholder="Rechercher..."/>
                                                </div>
                                                <div v-for="mag in filteredMagasins" :key="mag.pid"
                                                     @click="toggleAgence(mag)"
                                                     class="flex items-center px-3 py-2 text-sm hover:bg-gray-50 cursor-pointer">
                                                    <input type="checkbox" :checked="isAgenceSelected(mag)"
                                                           class="mr-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500 pointer-events-none"/>
                                                    {{ mag.name }}
                                                </div>
                                                <div v-if="filteredMagasins.length === 0" class="px-3 py-4 text-sm text-gray-500 text-center">
                                                    Aucune annexe trouvée
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Password Section (for add only) -->
                                    <div v-if="typeaction === 'add' && parseFloat(Items.useline) === 0" class="border-t pt-6">
                                        <div class="flex items-center mb-4">
                                            <div class="p-2 bg-gray-100 rounded-lg">
                                                <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                                                </svg>
                                            </div>
                                            <div class="ml-3">
                                                <h4 class="text-sm font-medium text-gray-900">Mot de passe initial</h4>
                                                <p class="text-sm text-gray-500">
                                                    Le mot de passe sera généré automatiquement et devra être modifié à la première connexion.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Advanced Tab Content -->
                            <div v-if="activeTab === 'advanced'" class="space-y-6">
                                <div class="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                                    <div class="flex items-start">
                                        <svg class="w-5 h-5 text-yellow-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                                        </svg>
                                        <div class="ml-3">
                                            <h4 class="text-sm font-medium text-yellow-800">Paramètres avancés</h4>
                                            <p class="text-sm text-yellow-600 mt-1">
                                                Ces paramètres sont destinés aux administrateurs avancés. Modifiez-les avec prudence.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <!-- Additional settings can be added here -->
                                <div class="space-y-4">
                                    <div class="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                                        <div>
                                            <label class="text-sm font-medium text-gray-700">Activer l'utilisateur</label>
                                            <p class="text-xs text-gray-500">L'utilisateur pourra se connecter au système</p>
                                        </div>
                                        <div class="relative inline-block w-12 h-6">
                                            <input
                                                    type="checkbox"
                                                    class="sr-only"
                                                    v-model="Items.useline"
                                                    true-value="0"
                                                    false-value="1"
                                            />
                                            <div
                                                    @click="Items.useline = Items.useline === '0' ? '1' : '0'"
                                                    :class="[
                          'absolute cursor-pointer w-full h-full rounded-full transition-colors duration-200',
                          Items.useline === '0' ? 'bg-green-500' : 'bg-gray-300'
                        ]"
                                            ></div>
                                            <div
                                                    :class="[
                          'absolute left-1 top-1 bg-white w-4 h-4 rounded-full transform transition-transform duration-200',
                          Items.useline === '0' ? 'translate-x-6' : 'translate-x-0'
                        ]"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal Footer -->
                    <div class="px-6 py-4 border-t bg-gray-50 flex justify-between items-center">
                        <div class="text-sm text-gray-500">
                            <span class="text-red-500">*</span> Champs obligatoires
                        </div>
                        <div class="flex space-x-3">
                            <button
                                    @click="close"
                                    type="button"
                                    class="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors"
                            >
                                Annuler
                            </button>

                            <button
                                    v-if="typeaction === 'add'"
                                    @click="saveItems"
                                    :disabled="isSubmitting"
                                    class="px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center space-x-2"
                            >
                                <svg v-if="isSubmitting" class="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                <span>{{ isSubmitting ? 'Enregistrement...' : 'Enregistrer' }}</span>
                            </button>

                            <button
                                    v-if="typeaction === 'update'"
                                    @click="updateItems"
                                    :disabled="isSubmitting"
                                    class="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center space-x-2"
                            >
                                <svg v-if="isSubmitting" class="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                <span>{{ isSubmitting ? 'Modification...' : 'Modifier' }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as JwtService from "@/common/jwt.service";
    import { randomString } from "@/allfunction";
    const axios = require('axios');

    export default {
        /* eslint-disable */
        name: "UserFormModal",

        computed: {

            logindisabled(){
                let mvalue =this.Items?.useline || 0

                return mvalue === 1;
            },

            filteredMagasins(){
                if (!this.agenceSearch) {
                    return this.otherdatamg.magasin || [];
                }
                const search = this.agenceSearch.toLowerCase();
                return (this.otherdatamg.magasin || []).filter(m =>
                    (m.name || '').toLowerCase().includes(search)
                );
            }

        },

        data() {
            return {
                isdisplay: false,
                messageerror: "",
                messagesucces: "",
                titlemodal: "",
                typeaction: "add",
                alldata: [],
                otherdatamg: {},
                Items: {},
                activeTab: 'basic',
                isSubmitting: false,
                validationErrors: {
                    name: "",
                    login: "",
                    groupeusers: "",
                    sysrole: ""
                },
                agenceDropdownOpen: false,
                agenceSearch: ""
            };
        },

        methods: {
            close() {
                this.agenceDropdownOpen = false;
                document.removeEventListener('click', this.closeAgenceDropdown);
                this.isdisplay = false;
                this.resetForm();
                this.$emit('closed');
            },

            show(titlemodal, typeaction, Items, alldata,otherdatamg) {
                this.titlemodal = titlemodal;
                this.typeaction = typeaction;
                this.Items = { ...Items, agence: (Items.agence && Array.isArray(Items.agence)) ? [...Items.agence] : [] };
                this.alldata = alldata || [];
                this.otherdatamg = otherdatamg || { magasin: [] };
                this.messagesucces = "";
                this.messageerror = "";
                this.activeTab = 'basic';
                this.isSubmitting = false;
                this.resetValidationErrors();
                this.isdisplay = true;
            },

            resetForm() {
                this.Items = {};
                this.validationErrors = {
                    name: "",
                    login: "",
                    groupeusers: "",
                    sysrole: ""
                };
                this.agenceDropdownOpen = false;
                this.agenceSearch = "";
            },

            toggleAgenceDropdown() {
                this.agenceDropdownOpen = !this.agenceDropdownOpen;
                if (this.agenceDropdownOpen) {
                    this.agenceSearch = "";
                    this.$nextTick(() => {
                        document.addEventListener('click', this.closeAgenceDropdown);
                        if (this.$refs.agenceSearchInput) {
                            this.$refs.agenceSearchInput.focus();
                        }
                    });
                }
            },

            closeAgenceDropdown(e) {
                if (!this.agenceDropdownOpen) return;
                const el = this.$el.querySelector('.relative');
                if (el && !el.contains(e.target)) {
                    this.agenceDropdownOpen = false;
                    document.removeEventListener('click', this.closeAgenceDropdown);
                }
            },

            isAgenceSelected(mag) {
                if (!this.Items.agence || !Array.isArray(this.Items.agence)) return false;
                return this.Items.agence.some(a => a.pid === mag.pid);
            },

            toggleAgence(mag) {
                if (!this.Items.agence || !Array.isArray(this.Items.agence)) {
                    this.Items.agence = [];
                }
                const idx = this.Items.agence.findIndex(a => a.pid === mag.pid);
                if (idx === -1) {
                    this.Items.agence.push(mag);
                } else {
                    this.Items.agence.splice(idx, 1);
                }
            },

            removeAgence(index) {
                if (this.Items.agence) {
                    this.Items.agence.splice(index, 1);
                }
            },

            resetValidationErrors() {
                this.validationErrors = {
                    name: "",
                    login: "",
                    groupeusers: "",
                    sysrole: ""
                };
            },

            validateForm() {
                this.resetValidationErrors();
                let isValid = true;

                // Validate name
                if (!this.Items.name || this.Items.name.trim() === "") {
                    this.validationErrors.name = "Le nom et prénom(s) sont obligatoires";
                    isValid = false;
                }

                // Validate login for non-admin users
                if (parseFloat(this.Items.useline) === 0) {
                    if (!this.Items.login || this.Items.login.trim() === "") {
                        this.validationErrors.login = "Le login est obligatoire";
                        isValid = false;
                    }
                }

                // Validate group
                if (!this.Items.groupeusers || this.Items.groupeusers === "") {
                    this.validationErrors.groupeusers = "Veuillez sélectionner un groupe";
                    isValid = false;
                }

                // Validate profile
                if (!this.Items.sysrole) {
                    this.validationErrors.sysrole = "Veuillez sélectionner un profil";
                    isValid = false;
                }

                return isValid;
            },

            validateField(field) {
                switch (field) {
                    case 'name':
                        if (!this.Items.name || this.Items.name.trim() === "") {
                            this.validationErrors.name = "Le nom et prénom(s) sont obligatoires";
                        } else {
                            this.validationErrors.name = "";
                        }
                        break;

                    case 'login':
                        if (parseFloat(this.Items.useline) === 0 && (!this.Items.login || this.Items.login.trim() === "")) {
                            this.validationErrors.login = "Le login est obligatoire";
                        } else {
                            this.validationErrors.login = "";
                        }
                        break;

                    case 'groupeusers':
                        if (!this.Items.groupeusers || this.Items.groupeusers === "") {
                            this.validationErrors.groupeusers = "Veuillez sélectionner un groupe";
                        } else {
                            this.validationErrors.groupeusers = "";
                        }
                        break;

                    case 'sysrole':
                        if (!this.Items.sysrole) {
                            this.validationErrors.sysrole = "Veuillez sélectionner un profil";
                        } else {
                            this.validationErrors.sysrole = "";
                        }
                        break;
                }
            },

            getHeaderIconColor() {
                return this.typeaction === 'add' ? 'bg-green-500' : 'bg-blue-500';
            },

            async saveItems() {
                if (!this.validateForm()) {


                    toastr['error']("Veuillez corriger les erreurs dans le formulaire","<b></b>");

                    return;
                }

                this.isSubmitting = true;
               // const t = this;

                let url = `${process.env.VUE_APP_API_URL}/setting/utilisateur/${this.$store.state.appsociete}/adduser/${randomString(200)}`;

                try {
                    const response = await axios.post(url, this.Items, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });

                    if (response.data.success) {
                        this.messagesucces = response.data.message;
                        this.messageerror = "";



                        toastr['success'](response.data.message,"<b></b>");


                        // Close modal after short delay
                        setTimeout(() => {
                            this.close();
                        }, 1500);
                    } else {
                        this.handleErrorResponse(response.data);
                    }
                } catch (error) {
                    console.error('Error saving user:', error);

                    toastr['error']("Une erreur est survenue. Veuillez contacter votre administrateur.","<b></b>");



                } finally {
                    this.isSubmitting = false;
                }
            },

            async updateItems() {
                if (!this.validateForm()) {

                    toastr['error']("Veuillez corriger les erreurs dans le formulaire","<b></b>");

                    return;
                }

                this.isSubmitting = true;
                //const t = this;

                let url = `${process.env.VUE_APP_API_URL}/setting/utilisateur/${this.$store.state.appsociete}/updtuser/${randomString(200)}`;

                try {
                    const response = await axios.post(url, this.Items, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });

                    if (response.data.success) {
                        this.messagesucces = response.data.message;
                        this.messageerror = "";

                        toastr['success'](response.data.message,"<b></b>");

                        // Close modal after short delay
                        setTimeout(() => {
                            this.close();
                        }, 1500);
                    } else {
                        this.handleErrorResponse(response.data);
                    }
                } catch (error) {
                    console.error('Error updating user:', error);


                    toastr['error']("Une erreur est survenue. Veuillez contacter votre administrateur.","<b></b>");


                } finally {
                    this.isSubmitting = false;
                }
            },

            handleErrorResponse(responseData) {
                this.messageerror = "";
                this.messagesucces = "";

                if (responseData.datamessage && responseData.datamessage.length > 0) {
                    const errorMessage = responseData.datamessage.join(', ');
                    this.messageerror = errorMessage;



                    toastr['error'](errorMessage,"<b></b>");



                } else {
                    this.messageerror = responseData.message;

                    toastr['error']( this.messageerror,"<b></b>");
                }
            }
        }
    };
</script>

<style scoped>
    /* Custom scrollbar */
    .max-h-\[calc\(90vh-140px\)\] {
        max-height: calc(90vh - 140px);
    }

    ::-webkit-scrollbar {
        width: 8px;
    }

    ::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }

    /* Smooth transitions */
    button, input, select {
        transition: all 0.2s ease;
    }

    /* Responsive adjustments */
    @media (max-width: 640px) {
        .grid-cols-1 {
            grid-template-columns: 1fr;
        }

        .flex-col {
            flex-direction: column;
        }

        .space-x-3 > :not([hidden]) ~ :not([hidden]) {
            margin-left: 0;
            margin-top: 0.75rem;
        }
    }

    /* Animation for success/error messages */
    @keyframes slideIn {
        from {
            transform: translateY(-10px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    .bg-green-50, .bg-red-50 {
        animation: slideIn 0.3s ease-out;
    }
</style>